











































































































































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "../main/components/main-header/main-header.vue";
import { GetCenter } from "@/request/sjzx";
@Component({
  components: {
    MainHeader,
  },
})
export default class Home extends Vue {
  private projects: any[] = [];
  private centers: any[] = [];
  private get user() {
    return this.$store.state.user;
  }
  /**
   * @description 获得中心列表
   */
  private fetchCenters() {
    GetCenter(this).then((data: any) => {
      this.centers = data;
    });
  }
  /**
   * @description 判断是否是长的中心列表
   */
  private decideIfLongCenters() {
    let num: number = 0;
    // if (this.user["治未病数据中心"]) {
    //   num += 1;
    // }
    // if (this.user["中医影像数据中心"]) {
    //   num += 1;
    // }
    num += this.centers.length;
    if (num >= 4) {
      return true;
    } else {
      return false;
    }
  }
  /**
   * @description 跳转数据看板
   */
  private jumpShujukanban() {
    this.$router.push({
      path: "/main/sjzx/shujukanban",
    });
  }
  /**
   * @description 跳转临床数据中心
   */
  private jumpZbsjk() {
    this.$router.push({
      path: "/main/sjzx/zbsjk-select",
    });
    // localStorage.setItem("center", JSON.stringify(center));
    // const filters = {
    //   hospital_ids: [],
    //   范围: [],
    //   search: "",
    //   性别: "",
    //   开始年龄: "",
    //   结束年龄: "",
    //   开始时间: "",
    //   结束时间: "",
    //   年龄段: [],
    //   timeWay: "",
    //   time: [],
    //   条件: "",
    //   研究指标: [],
    //   自定义年龄: [false],
    //   时间段: "",
    //   自定义时间段: [false, []],
    //   currentPage: 1,
    //   totalPage: 0,
    //   totalCount: 0,
    //   pageSize: 10,
    //   cSortField: "更新时间",
    //   cSortValue: "0",
    //   ifPrimarySearched: false,
    // };
    // switch (center["center"]) {
    //   case "临床科室数据中心":
    //     break;
    //   case "治未病数据中心":
    //     filters["体重"] = [];
    //     filters["单位"] = "";
    //     filters["备孕女性体质辨识"] = [];
    //     filters["孕期女性体质辨识"] = [];
    //     filters["产后女性体质辨识"] = [];
    //     filters["老年人体质类型"] = [];
    //     filters["儿童体质类型"] = [];
    //     filters["体质辨识"] = [];
    //     filters["四诊合参体质辨识"] = [];
    //     filters["慢性病"] = [];
    //     break;
    //   case "名中医传承数据中心":
    //     break;
    //   case "中医影像数据中心":
    //     break;
    // }
    // localStorage.setItem("zbsjkFilters", JSON.stringify(filters));
  }
  /**
   * @description 跳转智能看舌
   */
  private jumpTongueList() {
    localStorage.setItem(
      "tongueListFilters",
      JSON.stringify({
        hospital_ids: [],
        范围: [],
        search: "",
        性别: "",
        开始时间: "",
        结束时间: "",
        年龄段: [],
        timeWay: "",
        time: [],
        条件: "",
        研究指标: [],
        自定义年龄: [false],
        时间段: "",
        自定义时间段: [false, []],
        currentPage: 1,
        orderField: "创建时间",
        orderValue: 0,
        pageCount: 12,
        primaryFilters: {},
        totalCount: 0,
        ifPrimarySearched: false,
      })
    );
    this.$router.push("/main/tongue/tongue-list");
  }
  /**
   * @description 跳转自定义分析
   */
  private jumpCustomAnalysis(way: string) {
    this.$router.push({
      path: "/main/dig/custom-analysis",
      query: {
        way,
      },
    });
  }
  /**
   * @description 跳转教学管理
   */
  private jumpJxgl() {
    localStorage.setItem(
      "xtkListFilters",
      JSON.stringify({
        cate_id: "",
        题目难度: "",
        search: "",
        current_page: 1,
        page_count: 10,
        order_value: 0,
      })
    );
    this.$router.push("/main/jxgl/xtk-list");
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.fetchCenters();
  }
}
